var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7998 3.1C10.7998 2.44768 10.7998 2.12152 10.9064 1.86424C11.0485 1.5212 11.321 1.24866 11.664 1.10657C11.9213 1 12.2475 1 12.8998 1C13.5521 1 13.8783 1 14.1356 1.10657C14.4786 1.24866 14.7511 1.5212 14.8932 1.86424C14.9998 2.12152 14.9998 2.44768 14.9998 3.1V5.9C14.9998 6.55232 14.9998 6.87848 14.8932 7.13576C14.7511 7.4788 14.4786 7.75134 14.1356 7.89343C13.8783 8 13.5521 8 12.8998 8C12.2475 8 11.9213 8 11.664 7.89343C11.321 7.75134 11.0485 7.4788 10.9064 7.13576C10.7998 6.87848 10.7998 6.55232 10.7998 5.9V3.1Z",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7998 12.8998C10.7998 12.2475 10.7998 11.9213 10.9064 11.664C11.0485 11.321 11.321 11.0485 11.664 10.9064C11.9213 10.7998 12.2475 10.7998 12.8998 10.7998C13.5521 10.7998 13.8783 10.7998 14.1356 10.9064C14.4786 11.0485 14.7511 11.321 14.8932 11.664C14.9998 11.9213 14.9998 12.2475 14.9998 12.8998C14.9998 13.5521 14.9998 13.8783 14.8932 14.1356C14.7511 14.4786 14.4786 14.7511 14.1356 14.8932C13.8783 14.9998 13.5521 14.9998 12.8998 14.9998C12.2475 14.9998 11.9213 14.9998 11.664 14.8932C11.321 14.7511 11.0485 14.4786 10.9064 14.1356C10.7998 13.8783 10.7998 13.5521 10.7998 12.8998Z",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.8C1 9.48007 1 8.8201 1.41005 8.41005C1.8201 8 2.48007 8 3.8 8H5.2C6.51993 8 7.1799 8 7.58995 8.41005C8 8.8201 8 9.48007 8 10.8V12.2C8 13.5199 8 14.1799 7.58995 14.5899C7.1799 15 6.51993 15 5.2 15H3.8C2.48007 15 1.8201 15 1.41005 14.5899C1 14.1799 1 13.5199 1 12.2V10.8Z",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.1C1 2.44768 1 2.12152 1.10657 1.86424C1.24866 1.5212 1.5212 1.24866 1.86424 1.10657C2.12152 1 2.44768 1 3.1 1H5.9C6.55232 1 6.87848 1 7.13576 1.10657C7.4788 1.24866 7.75134 1.5212 7.89343 1.86424C8 2.12152 8 2.44768 8 3.1C8 3.75232 8 4.07848 7.89343 4.33576C7.75134 4.6788 7.4788 4.95134 7.13576 5.09343C6.87848 5.2 6.55232 5.2 5.9 5.2H3.1C2.44768 5.2 2.12152 5.2 1.86424 5.09343C1.5212 4.95134 1.24866 4.6788 1.10657 4.33576C1 4.07848 1 3.75232 1 3.1Z",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.230a04c2d3033277c16392c4756cd14b.svg";
export { ForwardRef as ReactComponent };